import styles from '../dist/tippy.css'
import tippy from '../src/js/tippy'
import { injectCSS } from '../src/js/utils'

injectCSS(styles)

export default tippy
